import { useState } from 'react'
import { signOut } from '../firebase/auth'
import './PermissionsPending.css'

const PermissionsPending = ({ user }) => {
  const [signingOut, setSigningOut] = useState(false)

  const handleSignOut = async () => {
    setSigningOut(true)
    try {
      await signOut()
    } catch (error) {
      console.error('Error signing out:', error)
      setSigningOut(false)
    }
  }

  return (
    <div className="permissions-pending-container">
      <div className="permissions-pending-card">
        <div className="permissions-pending-header">
          <h1>FileSig</h1>
          <p className="permissions-pending-email">{user?.email}</p>
        </div>

        <div className="permissions-pending-message">
          <p>Your account permissions are being set up.</p>
          <p>
            Once an administrator has assigned your access, sign out and sign back in for your
            permissions to take effect.
          </p>
        </div>

        <button
          type="button"
          className="permissions-pending-signout-btn"
          onClick={handleSignOut}
          disabled={signingOut}
        >
          {signingOut ? 'Signing out...' : 'Sign out'}
        </button>
      </div>
    </div>
  )
}

export default PermissionsPending
